export enum BookingEngineType {
  Hotel = 'Hotel',
  Condo = 'Condo',
  Car = 'Car',
  Activity = 'Activity',
  Both = 'Both',
}

export enum IssueReportStep {
  SearchResults = 'search-results',
  Availability = 'availability',
  PropertyDetail = 'property-detail',
  VehicleDetail = 'vehicle-detail',
  ActivityDetail = 'activity-detail',
  BookingSummary = 'booking-summary',
  Checkout = 'checkout',
  Payment = 'payment',
  Confirmation = 'confirmation',
  Recheck = 'recheck',
  Search = 'search',
  Other = 'other',
}

export interface IIssueReportLastError {
  endpoint: string;
  httpStatus: number | null;
  code?: string;
  message?: string;
  at: string;
}

export interface IIssueReportClient {
  browser: string;
  locale: string;
  viewport: string;
}

export interface IIssueReportCorrelation {
  sessionKey?: string | null;
  searchId?: string | null;
  bookingId?: string | null;
  packageId?: string | null;
}

export interface IIssueReportPayload {
  engine: BookingEngineType;
  step: string;
  correlation: IIssueReportCorrelation;
  request?: any;
  selection?: any;
  ui?: any;
  lastError?: IIssueReportLastError | null;
  client: IIssueReportClient;
}

// Snapshot of the current flow, resolved from the route and the store.
export interface IIssueReportContext {
  bookingEngine: BookingEngineType;
  step: string;
  // Must be a real GUID: the API binds anything else to Guid.Empty without failing.
  sessionId: string;
  payload: IIssueReportPayload;
}

export interface IIssueReportResponse {
  success: boolean;
  issueReportId: number;
}

export const ISSUE_REPORT_MAX_IMAGES = 3;
export const ISSUE_REPORT_MAX_IMAGE_SIZE = 5 * 1024 * 1024;
export const ISSUE_REPORT_MAX_COMMENT_LENGTH = 2000;
export const ISSUE_REPORT_ALLOWED_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.gif', '.webp'];
export const ISSUE_REPORT_ALLOWED_CONTENT_TYPES = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/webp',
];
export const ISSUE_REPORT_ACCEPT = ISSUE_REPORT_ALLOWED_CONTENT_TYPES.join(',');
